import AWS from "aws-sdk";

AWS.config.update({
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID_SES,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY_SES,
  region: process.env.REACT_APP_AWS_REGION,
});

const ses = new AWS.SES({ apiVersion: "2010-12-01" });

/**
 * Envía un correo electrónico usando AWS SES.
 * @param {Object} params - Parámetros del correo electrónico.
 * @param {string} params.from - Dirección de remitente.
 * @param {string} params.to - Dirección de destino.
 * @param {string} params.subject - Asunto del correo.
 * @param {string} params.message - Contenido del correo.
 */
export const sendEmailWithSES = async ({ from, to, subject, message }) => {
  const params = {
    Source: from,
    Destination: { ToAddresses: [to] },
    Message: {
      Subject: { Data: subject },
      Body: {
        Text: { Data: message },
      },
    },
  };

  return ses.sendEmail(params).promise();
};
